import billing_theme from "style/theme_colors";
import styled from "styled-components";

export const ViewModeloContent = styled.div`
  gap: 14px;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  height: 100%;
  .button {
    display: flex;
    gap: 12px;
    align-items: center;
    justify-content: center;
  }
`;

export const ViewModeloDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
